import styled from 'styled-components';

export const LineGraphContainer = styled.div`
  padding: 0 10px 10px;
  background: ${({ theme }) => theme.colors.white};
  position: relative;
`;
